export default "__VITE_ASSET__8UNc4bzI__"